<template>
	<section class='ad-wrapper' v-if="items">
		<div class='ad-img' v-for="(item,index) in items" :key="index">
			<img v-lazy="item.adv_code" v-if='item.adv_code' @click="goAdUrl(item)">
		</div>
	</section>
</template>

<script>
export default {
  name: 'IndexAd',
  data () {
    return {
    }
  },
  props: ['items'],
  computed: {

  },
  methods: {
    goAdUrl (item) {
      switch (item.adv_type) {
        case 'goods':
          this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.adv_typedate } })
          break
        case 'store':
          this.$router.push({ name: 'HomeStoredetail', query: { id: item.adv_typedate } })
          break
        case 'article':
          this.$router.push({ name: 'HomeArticledetail', query: { article_id: item.adv_typedate } })
          break
        case 'url':
          window.location.href=item.adv_typedate
          break  
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ad-wrapper{padding: .3rem $pageSpace;}
.ad-wrapper img {
  border-radius: .5rem;
  width: 100%;
  margin-bottom: .5rem;
}
</style>
